/// <reference types="jquery" />
import { ScopedEventHelper } from "Agile/Scripts/ScopedEventHelper";
import { AutoRefreshThrottler } from "Agile/Scripts/Common/AutoRefreshThrottler";
import { TaskboardWorkItemChangedPayload } from "Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardWorkItemChangedPayload";
import { Events } from "Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardAutoRefreshConstants";
import { PublishAutoRefreshTelemetry } from "Agile/Scripts/SprintsHub/Taskboard/AutoRefresh/TaskboardAutoRefreshTelemetry";
import FeatureAvailability_Services = require("VSS/FeatureAvailability/Services");
import ServerConstants = require("Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants");

export class TaskboardAutoRefreshThrottler extends AutoRefreshThrottler {
    private _teamId: string;

    constructor(teamId: string, eventsHelper: ScopedEventHelper) {
        super(eventsHelper);
        this._teamId = teamId;
        if (this._isFFEnabled) {
            // We are interest is this event only when throttling is enabled.
            this._attachAutoRefreshCompletedEvent();
        }
    }

    public process(workItemDataList: TaskboardWorkItemChangedPayload[]): void {
        super.process(workItemDataList);
    }

    protected fireItemsNeedAutoRefresh(workItemDataList: TaskboardWorkItemChangedPayload[]) {
        workItemDataList.map(workItemData => this._eventsHelper.fire(Events.ItemsNeedAutoRefresh, this, workItemData));
    }

    private _attachAutoRefreshCompletedEvent() {
        this.attachAutoRefreshCompletedEvent(Events.ItemsAutoRefreshCompleted);
    }

    private _detachAutoRefreshCompletedEvent() {
        this.detachAutoRefreshCompletedEvent(Events.ItemsAutoRefreshCompleted);
    }

    public dispose() {
        super.dispose();
        this._detachAutoRefreshCompletedEvent();
    }

    protected logThrottlingStoppedTelemetry() {
        PublishAutoRefreshTelemetry("WorkItemsRefreshThrotllingStopped", this._teamId, {});
    }

    protected logThrottlingStartedTelemetry() {
        var ciData: IDictionaryStringTo<any> = {
            RemainingItemsToRefresh: this.getRemainingItems()
        };
        PublishAutoRefreshTelemetry("WorkItemsRefreshThrotllingStarted", this._teamId, ciData);
    }

    protected logPipelineUnblockedTelemetry() {
        PublishAutoRefreshTelemetry("PipelineUnblocked", this._teamId, {});
    }

    protected checkFFStatus() {
        return !FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(
            ServerConstants.FeatureAvailabilityFlags.WebAccessAgileTaskboardLiveUpdatesDisableThrottling, false
        );
    }
}
